<template>
  <div class="wrapper">
    <page-header/>
    <div class="content container">
        <div class="my-auto text-center" v-if="cardDetailsInviteCompleted">
          <div class="form-group">
            <div role="alert" class="alert alert-info alert-icon alert-dismissible">
              <div class="alert-content"> {{ completed ?
                'Thank you for completing this request. We will review your payment details. This link is now closed.' :
                'This link is now closed. Please request a new one.' }}
              </div>
              <button aria-label="Close" class="close" data-dismiss="alert" type="button">
                <span aria-hidden="true">×</span>
              </button>
            </div>
          </div>
        </div>
      <div v-else class="col-md-8 mx-auto">
        <error-banner v-if="errors" :message="errors"></error-banner>
        <template v-if="clientCardDetailsInvite">
          <invite-processor v-model="processorStatus" :invite="clientCardDetailsInvite"></invite-processor>
        </template>
      </div>
    </div>
    <page-footer/>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { ClientCardDetailsInviteCacheMixin } from '../../mixins/CardDetailsInvite/ClientCardDetailsInviteCacheMixin'
import { ErrorHelper } from '@/helpers/ErrorHelper'
import ErrorBanner from '@/components/ErrorValidation/ErrorBanner.vue'
import PageHeader from '../Layout/PageHeader.vue'
import PageFooter from '../Layout/PageFooter.vue'
import CardDetailsInviteProcessor from './CardDetailsInviteProcessor.vue'

export default {
  name: 'CardDetailsInvitePage',
  mixins: [ClientCardDetailsInviteCacheMixin],
  data () {
    return {
      processorStatus: {}
    }
  },
  computed: {
    inviteId () {
      return this.$route.query.id
    },
    processorError () {
      return this.processorStatus ? this.processorStatus.error : ''
    },
    loading () {
      return this.processorStatus ? this.processorStatus.loading : false
    },
    completed () {
      return this.processorStatus ? this.processorStatus.completed : false
    },
    errors () {
      const errorsArray = [this.error, this.processorError].filter(err => !!err)
      return errorsArray.join(' ')
    },
    cardDetailsInviteCompleted () {
      return !!this.completed || this.clientCardDetailsInviteStatusId === 3
    }
  },
  watch: {
    clientCardDetailsInviteStatusId (value) {
      if (value === 1) {
        this.tryViewClientCardDetailsInvite()
      }
    },
    completed (value) {
      if (value) {
        this.tryCompleteClientCardDetailsInvite()
      }
    }
  },
  methods: {
    ...mapActions('ClientCardDetailsInvites', [
      'viewClientCardDetailsInvite',
      'completeClientCardDetailsInvite'
    ]),
    tryViewClientCardDetailsInvite () {
      const self = this
      if (!self.inviteId) {
        return
      }
      self.error = ''
      self.viewClientCardDetailsInvite(self.inviteId)
        .catch(error => { self.error = ErrorHelper.getError(error) })
    },
    tryCompleteClientCardDetailsInvite () {
      const self = this
      if (!self.inviteId) {
        return
      }
      self.error = ''
      self.completeClientCardDetailsInvite(self.inviteId)
        .catch(error => { self.error = ErrorHelper.getError(error) })
    }
  },
  components: {
    'error-banner': ErrorBanner,
    'page-header': PageHeader,
    'page-footer': PageFooter,
    'invite-processor': CardDetailsInviteProcessor
  }
}
</script>
